<template>
    <div v-if="question.all_child_questions.length > 0 && question.answers.length === 0">
        <table class="table table-bordered" width="100%">
            <tbody>
            <tr v-for="(child_questions, index_child_questions) in question.all_child_questions"
                :key="index_child_questions">
                <th>
                    {{child_questions.title}}
                </th>
                <td>
                    <b-form-radio-group required
                                        v-model="getAnswersByQuestionId(question.id).answer_id">
                        <b-form-radio v-for="answer in child_questions.answers"
                                      :key="answer.id"
                                      v-model="getAnswersByQuestionId(question.id).answer_id"
                                      :value="answer.id"
                                      :checked="true"
                        >
                            {{answer.name}}
                        </b-form-radio>
                    </b-form-radio-group>
                </td>
            </tr>
            </tbody>
        </table>


    </div>
    <div v-else>
        <div v-for="(child_questions, index_child_questions) in question.all_child_questions"
             :key="index_child_questions">
            <!-- Question Asset -->
            <b-row align-v="center" v-if="child_questions.asset_question != null">
                <b-col md="12" class="profile-padding">
                    <!-- video link -->
                    <b-embed
                            v-if="child_questions.asset_question.type === 'url'"
                            type="iframe"
                            aspect="16by9"
                            :src="child_questions.asset_question.url"
                            allowfullscreen
                    />
                    <!--/video link -->

                    <!-- Image -->
                    <b-img v-else-if="child_questions.asset_question.type === 'image'"
                           :src="serverUrl + '/' + child_questions.asset_question.url"
                           fluid
                           alt="Responsive image"/>
                    <!--/Image-->

                    <!-- MP4 -->
                    <b-embed v-else-if="child_questions.asset_question.type === 'video'"
                             type="video" aspect="4by3" controls>
                        <source :src="serverUrl + '/' + child_questions.asset_question.url"
                                type="video/mp4;codecs=&quot;avc1.42E01E, mp4a.40.2&quot;"/>
                    </b-embed>
                    <!--/MP4-->
                </b-col>
            </b-row>
            <!--/Question Asset -->
            <b-card-group deck>
                <b-card header-tag="header">
                    <h6 slot="header" class="mb-0">
                        {{child_questions.number}} {{child_questions.title}}
                    </h6>
                    <b-card-text>
                        <!-- child questions -->
                        <div v-if="child_questions.all_child_questions.length > 0">
                            <table class="table table-bordered" width="100%">
                                <tbody>
                                <tr v-for="(child_question, index_child_questions) in child_questions.all_child_questions"
                                    :key="index_child_questions">
                                    <th>
                                        {{child_question.title}}
                                    </th>
                                    <td>
                                        <!-- radio -->
                                        <b-form-radio-group v-if="child_question.answer_type_id === 1"
                                                            :required="true" :key="question.id"
                                                            :name="`${index_child_questions}`"
                                                            v-model="getAnswersByQuestionId(question.id).answer_id"
                                        >
                                            <b-form-radio v-for="answer in child_question.answers"
                                                          :key="answer.id"
                                                          v-model="getAnswersByQuestionId(question.id).answer_id"
                                                          :value="answer.id"
                                            >
                                                <b-img v-if="answer.image !== null"
                                                       :src="serverUrl + '/' + answer.image"
                                                       width="30px"
                                                       height="30px"
                                                />
                                                {{answer.name}}
                                                <b-form-input v-if="answer.is_other"
                                                              type="text"
                                                              v-model="getAnswersByQuestionId(question.id).answer_other_value"
                                                              placeholder="รายละเอียด"
                                                />
                                            </b-form-radio>
                                        </b-form-radio-group>
                                        <!--/radio -->

                                        <!-- date -->
                                        <div v-else-if="child_question.answer_type_id === 2">
                                            <b-col md="3">
                                                <b-form-input v-for="(answer, index_answer) in child_question.answers"
                                                              :key="index_answer"
                                                              v-model="getAnswersByQuestionId(question.id).answer_id"
                                                              type="date"/>
                                            </b-col>
                                        </div>
                                        <!--/date -->

                                        <!--input -->
                                        <div v-else-if="child_question.answer_type_id === 3">
                                            <b-row class="my-1" v-for="(answer, index_answer) in child_question.answers"
                                                   :key="index_answer">
                                                <b-col v-if="answer.unit !== null">
                                                    <label :for="answer.id.toString()">{{answer.name}}</label>
                                                </b-col>
                                                <b-col>
                                                    <b-form-input :id="answer.id.toString()"
                                                                  v-model="getAnswersByQuestionId(question.id).answer_value"
                                                                  type="text"
                                                    />
                                                </b-col>
                                                <b-col v-if="answer.unit !== null">
                                                    <label :for="answer.id.toString()">
                                                        {{answer.unit}}
                                                    </label>
                                                </b-col>
                                            </b-row>
                                        </div>
                                        <!--/input -->

                                        <!-- checkbox -->
                                        <b-form-checkbox-group stacked
                                                               :required="true"
                                                               v-else-if="child_question.answer_type_id === 4"
                                                               v-model="getAnswersByQuestionId(question.id).answer_id"
                                        >
                                            <b-form-checkbox v-for="(answer, index_answer) in child_question.answers"
                                                             :key="index_answer"
                                                             v-model="getAnswersByQuestionId(question.id).answer_id"
                                                             :value="answer.id"
                                            >
                                                <b-img v-if="answer.image !== null"
                                                       :src="serverUrl + '/' + answer.image"
                                                       width="30px"
                                                       height="30px"
                                                />
                                                {{answer.name}}
                                                <b-form-input v-if="answer.is_other"
                                                              type="text"
                                                              v-model="getAnswersByQuestionId(question.id).answer_other_value"
                                                              placeholder="รายละเอียด"
                                                />
                                            </b-form-checkbox>
                                        </b-form-checkbox-group>
                                        <!--/checkbox -->
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <!--/child questions -->
                    </b-card-text>
                </b-card>
            </b-card-group>
            <br>
        </div>
    </div>
</template>

<script>
    import BCardText from "bootstrap-vue/src/components/card/card-text";
    import BFormRadioGroup from "bootstrap-vue/src/components/form-radio/form-radio-group";
    import BFormRadio from "bootstrap-vue/src/components/form-radio/form-radio";
    import BFormInput from "bootstrap-vue/src/components/form-input/form-input";
    import BImg from "bootstrap-vue/src/components/image/img";
    import BCol from "bootstrap-vue/src/components/layout/col";
    import BFormCheckboxGroup from "bootstrap-vue/src/components/form-checkbox/form-checkbox-group";
    import BFormCheckbox from "bootstrap-vue/src/components/form-checkbox/form-checkbox";
    import BRow from "bootstrap-vue/src/components/layout/row";
    import BCardGroup from "bootstrap-vue/src/components/card/card-group";
    import BCard from "bootstrap-vue/src/components/card/card";

    export default {
        name: "ChildQuestions",
        components: {
            BCard,
            BCardGroup,
            BRow,
            BFormCheckbox,
            BFormCheckboxGroup,
            BCol,
            BImg,
            BFormInput,
            BFormRadio,
            BFormRadioGroup,
            BCardText
        },
        props: ["question", "form"]
    }
</script>

<style scoped>

</style>